import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import apis from "services";
import DealTerm from "./DealTerm";
import OpenHeader from "./OpenHeader";
import OpenPitch from "./OpenPitch";
import PitchCard from "./PitchCard";

const OpenSection = ({ categories, setting }) => {
  const [tab, setTab] = useState(0);
  const [subTab, setSubTab] = useState("problem");

  const [data, setData] = useState([]);
  const openPitch = useRef();

  const fetchData = async () => {
    const res = await apis.getRecentUserInvest();
    setData(res?.data?.recentUser);
  };
  useEffect(() => {
    (async () => {
      await fetchData();
    })();
  }, []);

  useEffect(() => {
    setTab(categories[0]?.id);
    setSubTab(categories[0]?.services[0]?.id);
  }, [categories])

  return (
    <>
      <div className="sec-eight-wrap">
        <div className="inner">
          <div className="left">
            <OpenHeader
              tab={tab}
              setTab={setTab}
              subTab={subTab}
              setSubTab={setSubTab}
              openPitch={openPitch}
              categories={categories}
            />
          </div>
          <div className="right">
          <div className="bg-overlay"></div>
            <div className="pitch-cardd">
              <PitchCard setting={setting} />
            </div>
            <div className="accrodian">
                <OpenPitch openPitch={openPitch} subTab={subTab} data={data} categories={categories} />
            </div>
            {/* <Row>
              <Col lg={8}>
              </Col>
              <Col lg={4}>
                <PitchCard setting={setting} />
              </Col>
            </Row> */}
          </div>
        </div>
      </div>
      {/* <Container>
        <Row>
          <Col lg={2}>
            <OpenHeader
              tab={tab}
              setTab={setTab}
              subTab={subTab}
              setSubTab={setSubTab}
              openPitch={openPitch}
              categories={categories}
            />
          </Col>
          <Col lg={10}>
            <Row>
              <Col lg={8}>
                <OpenPitch openPitch={openPitch} subTab={subTab} data={data} categories={categories}/>
              </Col>
              <Col lg={4}>
                <PitchCard setting={setting}/>
                <p className="section-title">Recent Investments</p>
            <div className="deal-term-wrapper">
              {data?.slice(0, 8).map((item, index) => {
                return (
                  <>
                    <DealTerm key={index} data={item} />
                  </>
                );
              })}
            </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container> */}
    </>
  );
};

export default OpenSection;
